import { createFileRoute, Outlet } from '@tanstack/react-router';

function CollectionDetailRoute() {
  return <Outlet />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/collections/$collectionId')({
  component: CollectionDetailRoute,
});
